type SearchableEntry = {
  name: string | null;
  email: string;
};

export const handleSearchStudent = <T extends SearchableEntry>(value: string, searchList: T[]): T[] => {
  const searchTerm = value.trim().toLocaleLowerCase().replace(/\s+/g, ' ');

  if (!searchTerm) {
    return searchList;
  }

  const words = searchTerm.split(' ');

  return searchList.filter((entry) => {
    const haystack = `${entry.email} ${entry.name ?? ''}`.toLocaleLowerCase();
    return words.every((word) => haystack.includes(word));
  });
};
